export const iconsFactory =
  (path: string) =>
  (name: string): string =>
    name.startsWith('@tui.')
      ? `${path}/${name.replace('@tui.', '').split('.').join('/')}.svg`
      : `/assets/icons/${name}.svg`;
